























import Vue from 'vue';
import { Prop, Component, Model, Watch } from 'vue-property-decorator';

/**
 * Composant de barre de zoom dynamique.
 */
@Component
export default class DynamicZoom extends Vue {
	/** Propriétés */
	@Prop()
	minZoom!: number;

	@Prop()
	maxZoom!: number;

	/** v-model */
	@Model('zoom-changed')
	zoom!: number;

	/** Attributs */
	internalZoom: number = 1;

	get zoomStep() {
		return 1;
	}

	get zoomLabels() {
		return [...Array(this.maxZoom - this.minZoom + 1).keys()].map(h => this.sliderLabelWithSuffix(h + this.minZoom));
	}

	/** Méthodes */
	zoomOut() {
		this.internalZoom = (this.internalZoom - this.zoomStep) || this.minZoom;
	}
	zoomIn() {
		this.internalZoom = (this.internalZoom + this.zoomStep) || this.maxZoom;
	}

	sliderLabelWithSuffix(n: number) {
		return `${n}x`;
	}

	/** Watchers */
	@Watch('internalZoom')
	internalZoomChanged() {
		this.$emit('zoom-changed', this.internalZoom);
	}

	@Watch('zoom')
	zoomChanged() {
		this.internalZoom = this.zoom;
	}
}
